import { ApiRoutes } from "@/api/client";
import { getResourcePage } from "@/api/helpers";
import { DestinationActivity, PaginationParams, PaginationResponse } from "@/types";

const getDestinationActivities = async (
  paginationParams: PaginationParams,
  filters: Record<string, string> = {},
): Promise<PaginationResponse<DestinationActivity>> => {
  return getResourcePage<DestinationActivity, { activity_logs: DestinationActivity[] | null }>(
    `${ApiRoutes.DESTINATION_ACTIVITY}`,
    paginationParams,
    (response) => response.data.data.activity_logs ?? [],
    "Failed to fetch activities.",
    filters,
  );
};

const DestinationActivityService = {
  getDestinationActivities,
};

export default DestinationActivityService;
